import _ from 'lodash';

import { OPEN_POPUP, CLOSE_POPUP, VIRTUALS_VIDEO_STREAM } from '@common/actionTypes';
import {
  SAVE_POPUP_TIMER,
  TOGGLE_POPUP_TIMER,
  CHECK_CASHOUT_TICKET,
  DATA_FINISHED, CHECKED_TICKETS, TICKET_SCAN,
  OPEN_IDLE_POPUP,
  CLOSE_IDLE_POPUP,
} from '../actions/actionTypes';

const UIStateReducer = (
  state = {
    loading: {},
    confirmation: {},
    virtualsParams: {},
    tickets: {},
    isFinished: false,
    checkedTickets: null,
    cashoutTicket: null,
    timer: null,
    showTimer: false,
  },
  action = {},
) => {
  const ret = _.cloneDeep(state);

  switch (action.type) {
    case SAVE_POPUP_TIMER:
      ret.timer = action.payload;
      return ret;
    case TOGGLE_POPUP_TIMER:
      ret.showTimer = action.payload;
      return ret;
    case TICKET_SCAN:
      if (action.bool) {
        if (ret.tickets[action.barcode]) delete ret.tickets[action.barcode];
        ret.tickets = { ...ret.tickets, ...action.payload };
      } else if (action.payload && !action.bool) {
        const newState = ret.tickets;
        delete newState[action.payload];
        ret.tickets = { ...newState };
      } else {
        ret.tickets = {};
      }
      return ret;
    case DATA_FINISHED:
      ret.isFinished = action.payload;
      return ret;
    case CHECK_CASHOUT_TICKET:
      ret.cashoutTicket = action.payload;
      return ret;
    case CHECKED_TICKETS:
      ret.checkedTickets = action.payload;
      return ret;
    case CLOSE_POPUP:
      ret.popup = null;
      ret.popupParams = null;
      return ret;
    case OPEN_POPUP:
      ret.popup = action.key;
      ret.popupParams = action.payload;
      return ret;
    case CLOSE_IDLE_POPUP:
      ret.idlePopupOpen = false;
      return ret;
    case OPEN_IDLE_POPUP:
      ret.idlePopupOpen = true;
      return ret;
    case VIRTUALS_VIDEO_STREAM:
      ret.virtualsParams = action.payload;
      return ret;
    default:
      return state;
  }
};

export default UIStateReducer;
